(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Dire_Slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ospear-hero-slider')) {
    customElements.define('ospear-hero-slider', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-go]')];
        this.index = 0;

        this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1));

        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => this.go(index));
        });

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());

        this.addEventListener('focusout', () => {
          if (!this.contains(document.activeElement)) this.start();
        });

        this.addEventListener('shopify:block:select', event => {
          const slide = event.target.closest('[data-slide]');
          if (slide) this.go(Number(slide.dataset.index));
          this.stop();
        });

        this.addEventListener('touchstart', event => {
          this.touchStartX = event.changedTouches[0].screenX;
        }, { passive: true });

        this.addEventListener('touchend', event => {
          const difference = event.changedTouches[0].screenX - this.touchStartX;
          if (Math.abs(difference) > 50) {
            this.go(this.index + (difference < 0 ? 1 : -1));
          }
        }, { passive: true });

        this.start();
      }

      disconnectedCallback() {
        this.stop();
      }

      go(next) {
        if (this.slides.length < 2) return;

        this.index = (next + this.slides.length) % this.slides.length;

        this.slides.forEach((slide, index) => {
          const active = index === this.index;
          slide.dataset.active = String(active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
        });

        this.dots.forEach((dot, index) => {
          dot.setAttribute('aria-current', String(index === this.index));
        });

        const status = this.querySelector('[data-status]');
        if (status) {
          status.textContent = `Slide ${this.index + 1} of ${this.slides.length}`;
        }
      }

      
start() {
  this.stop();

  if (
    this.dataset.autoplay !== 'true' ||
    this.slides.length < 2 ||
    this.contains(document.activeElement) ||
    window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
    window.Shopify?.designMode
  ) return;

  this.timer = window.setInterval(
    () => this.go(this.index + 1),
    Number(this.dataset.interval) || 6000
  );
}


      stop() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
